//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductThumb from '@product/components/ProductThumb'

export default {
  components: {
    ProductThumb,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    wide: {
      type: Boolean,
      required: true,
    },
  },
}
